<template>
<div class="loading-card px-4 bgc-greenfour d-flex align-items-center justify-content-between">
    <div class="d-flex align-items-center">
        <Loading class="mr-2 load-animation" color="white"/>
        <p>Aguarde enquanto preparamos seu arquivo para download...</p>
    </div>
    <button class="px-0" @click="$store.commit('user/setIsDownloadLoading', false)">
        <Close color="white"/>
    </button>
</div>
</template>

<script>
import Close from '@/components/icons/Close.vue'
import Loading from '@/components/icons/Loading.vue'

export default {
    components: {
    Close,
    Loading
}
}
</script>

<style lang="scss">
.loading-card {
    position: fixed;
    width: 600px;
    height: 48px;
    border-radius: 8px;
    color: white;
    z-index: 9;
    margin: auto;
    top: 24px;
    left: calc(0% + 256px); /* 256px == sidebar width */
    right: 0;
    .load-animation {
        -webkit-animation: rotating 2s linear infinite;
        -moz-animation: rotating 2s linear infinite;
        -ms-animation: rotating 2s linear infinite;
        -o-animation: rotating 2s linear infinite;
        animation: rotating 2s linear infinite;
    }
    p {
        font-weight: 500;
    }
    button {
        border: none;
        background: none;
        margin-top: -2px;
    }
}
</style>
